import { render } from "./raw-displayer.vue?vue&type=template&id=3889089c&scoped=true"
import script from "./raw-displayer.vue?vue&type=script&lang=js"
export * from "./raw-displayer.vue?vue&type=script&lang=js"

import "./raw-displayer.vue?vue&type=style&index=0&id=3889089c&scoped=true&lang=css"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3889089c"]])

export default __exports__